import React from "react";

import { Container } from "@mui/material";
import Chart from "./Chart.jsx";

const Sweep = ({ clientJson, c_callback }) => {
  return (
    <Container maxWidth="false" >
      <Chart clientJson={clientJson} c_callback={c_callback} uuid={clientJson.Sweep.uuid} />
    </Container>
  );
};

export default Sweep;
